import React, { Component } from 'react';

const SECTIONS = [
  { id: 'about', label: 'About' },
  { id: 'featured', label: 'Featured' },
  { id: 'resume', label: 'Experience' },
  { id: 'leadership', label: 'Leadership' },
  { id: 'education', label: 'Education' },
  { id: 'portfolio', label: 'Projects' },
];

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = { stuck: false };
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    const stuck = window.scrollY > 120;
    if (stuck !== this.state.stuck) this.setState({ stuck });
  }

  render() {
    const name = this.props.sharedBasicInfo ? this.props.sharedBasicInfo.name : '';
    return (
      <nav className={'site-nav' + (this.state.stuck ? ' site-nav--stuck' : '')}>
        <div className='site-nav__inner'>
          <a className='site-nav__name' href='#home'>
            {name}
          </a>
          <ul className='site-nav__links'>
            {SECTIONS.map((s) => (
              <li key={s.id}>
                <a href={'#' + s.id}>{s.label}</a>
              </li>
            ))}
          </ul>
        </div>
      </nav>
    );
  }
}

export default Nav;
